module.exports = __webpack_public_path__ + "media/images/wjc-logo-white-60bcc97f40fce4ae0c1e5cd79eaf938c.svg";